module.exports = __webpack_public_path__ + "img/member-pic-01.8598986d.png";